var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import styled from 'styled-components';
import { space, width, alignItems, justifyContent, flexWrap, flexDirection } from 'styled-system';
import { Box } from '../Box';
import { applyVariations, deprecatedPropType, deprecatedColorValue } from '../utils';
var propTypes = __assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign({}, space.propTypes), width.propTypes), { color: deprecatedColorValue(), bg: deprecatedPropType('color') }), alignItems.propTypes), justifyContent.propTypes), flexWrap.propTypes), flexDirection.propTypes), { wrap: deprecatedPropType('flexWrap'), align: deprecatedPropType('alignItems'), justify: deprecatedPropType('justifyContent') });
var Flex = styled(Box).attrs(function (_a) {
    var wrap = _a.wrap, align = _a.align, justify = _a.justify, props = __rest(_a, ["wrap", "align", "justify"]);
    return (__assign({ flexWrap: wrap ? 'wrap' : undefined, alignItems: align, justifyContent: justify }, props));
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  ", "\n  ", " ", "\n  ", "\n  ", "\n"], ["\n  display: flex;\n  ", "\n  ", " ", "\n  ", "\n  ", "\n"])), applyVariations('Flex'), alignItems, justifyContent, flexDirection, flexWrap);
Flex.propTypes = propTypes;
Flex.displayName = 'Flex';
export default Flex;
var templateObject_1;
//# sourceMappingURL=Flex.js.map